export default __webpack_public_path__ + "media/images/users/user-john-doe-70x70-cd80de622abdd8d7a256ba16ade941f9.jpg";